import script from "./detailFacility.vue?vue&type=script&setup=true&lang=js"
export * from "./detailFacility.vue?vue&type=script&setup=true&lang=js"

import "./detailFacility.vue?vue&type=style&index=0&id=c08b42f8&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c08b42f8"]])

export default __exports__